module.exports = __webpack_public_path__ + "media/images/logo_small-c1313bdc114eea4e647149792b8fb070.svg";